// Monitor service. Sends browser events to the backend for AI content analysis (used by DevTools SimulationPanel).
import { API_URL } from './apiClient';

export interface DetectionAnalysis {
  isFlagged: boolean;
  detectionType: string;
  severity: string;
  confidence: number;
  flagReason: string;
}

export interface MonitorEventResponse {
  message: string;
  flagged: boolean;
  analysis: DetectionAnalysis;
}

export interface MonitorEventListItem {
  id: string;
  studentId: string;
  studentName: string;
  eventType: string;
  url: string | null;
  domain: string | null;
  pageTitle: string | null;
  isFlagged: boolean;
  flagReason: string | null;
  createdAt: string;
}

export interface PaginatedMonitorEventsResponse {
  data: MonitorEventListItem[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const monitorService = {
  /**
   * Send a browser event (simulated) to the backend
   */
  async sendEvent(email: string, content: string, url: string = window.location.href): Promise<MonitorEventResponse> {
    const authToken = sessionStorage.getItem('authToken');
    const hdrs: Record<string, string> = { 'Content-Type': 'application/json' };
    if (authToken) hdrs['Authorization'] = `Bearer ${authToken}`;

    const response = await fetch(`${API_URL}/monitor/event`, {
      method: 'POST',
      headers: hdrs,
      body: JSON.stringify({
        email,
        content,
        url,
        domain: new URL(url).hostname
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to send monitor event');
    }

    return response.json();
  },

  async getEvents(page: number = 1, limit: number = 20): Promise<PaginatedMonitorEventsResponse> {
    const token = sessionStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/monitor/events?page=${page}&limit=${limit}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch monitor events');
    }

    return response.json();
  },

  async reloadKeywords(): Promise<{ reloaded: boolean; total_patterns: number }> {
    const token = sessionStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/monitor/reload-keywords`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      }
    });
    if (!response.ok) throw new Error('Failed to reload keywords');
    return response.json();
  },
};
